<template>
    <div class="site-section site-section--with-bg site-section--contact">
        <div class="contact-page-filter" v-if="countries.length > 0 || states.length > 0 || segments.length > 0">
            <div class="site-row">
                <div class="filter-section filter-section--padding-grid">
                    <div class="filter-items">
                        <div class="filter-item filter-item--mw" v-if="countries.length > 0">
                            <label class="sr-only"
                                for="countryFilter">{{ dictionaries.ContactCountryOptionDefault }}</label>
                            <select id="countryFilter" name="countryFilter" @change="filterChanged(true)"
                                :disabled="isLoading" v-model="country" class="filter-item__select">
                                <option value="All">{{ dictionaries.ContactCountryOptionDefault }}</option>
                                <option :value="country.Key" v-for="(country, index) in countries" v-if="country.Name">
                                    {{ country.Name }}</option>
                            </select>
                        </div>
                        <div class="filter-item filter-item--mw" v-if="states.length > 0">
                            <label class="sr-only" for="stateFilter">{{ dictionaries.ContactStateOptionDefault }}</label>
                            <select id="stateFilter" name="stateFilter" @change="filterChanged()" :disabled="isLoading"
                                v-model="state" class="filter-item__select">
                                <option value="All">{{ dictionaries.ContactStateOptionDefault }}</option>
                                <option :value="state.Key" v-for="(state, index) in states" v-if="state.Name">
                                    {{ state.Name }}</option>
                            </select>
                        </div>
                        <div class="filter-item filter-item--mw" v-if="segments.length > 0">
                            <label class="sr-only"
                                for="segmentFilter">{{ dictionaries.ContactSegmentOptionDefault }}</label>
                            <select id="segmentFilter" name="segmentFilter" @change="filterChanged()"
                                :disabled="isLoading" v-model="segment" class="filter-item__select">
                                <option value="All">{{ dictionaries.ContactSegmentOptionDefault }}</option>
                                <option :value="segment.Key" v-for="(segment, index) in segments" v-if="segment.Name">
                                    {{ segment.Name }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <button type="button" class="filter-item__button" @click="resetFilter"
                                :disabled="isLoading">{{ dictionaries.ContactFilterReset }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-page-distributors" v-if="!isLoading && distributors.length">
            <div class="site-row">
                <div class="contact-page-section">
                    <div class="distributor-items">
                        <distributorItem v-for="distributorItem in distributors" :distributorItem="distributorItem"
                            :key="distributorItem.Id" :dictionaries="dictionaries"></distributorItem>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-page-dealers" v-if="!isLoading && dealers.length">
            <div class="site-row">
                <div class="contact-page-section">
                    <div class="dealer-items">
                        <dealerItem v-for="dealerItem in dealers" :dealerItem="dealerItem" :key="dealerItem.Id"
                            :dictionaries="dictionaries"></dealerItem>
                    </div>
                </div>
            </div>
        </div>
        <div class="contact-page-employees" v-if="!isLoading && employees.length">
            <div class="site-row">
                <div class="contact-page-section">
                    <div class="employee-items">
                        <employeeItem v-for="employeeItem in employees" :employeeItem="employeeItem"
                            :key="employeeItem.Id" :dictionaries="dictionaries"></employeeItem>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DistributorItem from "./components/distributorItem.vue";
import DealerItem from "./components/dealerItem.vue";
import EmployeeItem from "./components/employeeItem.vue";
import { bindRoute } from "./mixins/bindroute.js";

const serviceUrl = "/umbraco/api/contact/getCountryContactInfo",
    defaultCountry = "All",
    defaultState = "All",
    defaultSegment = "All";

export default {
    name: "contact",
    components: {
        DistributorItem,
        DealerItem,
        EmployeeItem
    },
    data() {
        return {
            dictionaries: [],
            countries: [],
            states: [],
            segments: [],
            distributors: [],
            dealers: [],
            employees: [],
            isLoading: false
        };
    },
    created() {
        this.contactPageId = this.$parent.contactPageId;
        this.getInitialData();
    },
    mixins: [
        bindRoute({
            country: defaultCountry,
            state: defaultState,
            segment: defaultSegment
        })
    ],
    methods: {
        getData() {
            var vm = this,
                languageCode = $("html").attr("lang");
            vm.toggleSpinner(true);
            var object = {
                languageCode: languageCode
            };
            if (this.country != defaultCountry) {
                object.country = this.country;
            }
            if (this.state != defaultState) {
                object.state = this.state;
            }
            if (this.segment != defaultSegment) {
                object.segment = this.segment;
            }
            if (this.contactPageId) {
                object.contactPageId = this.contactPageId;
            }
            $.get(serviceUrl, object, function (response) {
                vm.dictionaries = response.Dictionaries;
                vm.countries = response.Facets.Countries;
                vm.states = response.Facets.States;
                vm.segments = response.Facets.Segments;
                vm.distributors = response.Distributors;
                vm.dealers = response.Dealers;
                vm.employees = response.Employees;
            }).fail(function (error) {
                console.log(error);
            }).always(function () {
                vm.toggleSpinner(false);
            });
        },
        getInitialData() {
            this.getData();
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            if (isLoading) {
                $("body").addClass("is-loading");
            } else {
                $("body").removeClass("is-loading");
            }
        },
        filterChanged(isCountry) {
            if (isCountry) {
                // Reset state if country is being updated & states is present
                if (this.states.length) {
                    this.state = defaultState;
                }
                // Reset state & segment if country is being set to default value
                if (this.country == defaultCountry) {
                    this.state = defaultState;
                    this.segment = defaultSegment;
                }
            }
            this.getData();
        },
        resetFilter() {
            this.country = defaultCountry;
            this.state = defaultState;
            this.segment = defaultSegment;
            this.getData();
        }
    }
};
</script>